import { t as uiText } from '../i18n';
import React from 'react';
import './ManagementPanel.css';
import type { HomeTabKey } from '../pages/AgentHomePage';

interface ManagementPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateTo: (tab: HomeTabKey) => void;
  isAdmin: boolean;
  isPublishEnabled: boolean;
}

interface PanelItem {
  label: string;
  tab: HomeTabKey;
  group: string;
  adminOnly?: boolean;
  publishOnly?: boolean;
}

const PANEL_ITEMS: PanelItem[] = [
  // 知識
  { get label() { return uiText("Page"); }, tab: 'page', get group() { return uiText("Knowledge"); } },
  { get label() { return uiText("Thread"); }, tab: 'thread', get group() { return uiText("Knowledge"); } },
  { get label() { return uiText("Calendar"); }, tab: 'calendar', get group() { return uiText("Knowledge"); } },
  { get label() { return uiText("File"); }, tab: 'file', get group() { return uiText("Knowledge"); } },
  { get label() { return uiText("Hashtag"); }, tab: 'hashtag', get group() { return uiText("Knowledge"); } },
  // 公開 RAG
  { get label() { return uiText("Publish settings"); }, tab: 'public', get group() { return uiText("Public RAG"); }, adminOnly: true, publishOnly: true },
  { label: 'DRS', tab: 'suggest', get group() { return uiText("Public RAG"); }, adminOnly: true, publishOnly: true },
  { label: 'OGA', tab: 'oga', get group() { return uiText("Public RAG"); }, adminOnly: true, publishOnly: true },
  // 分析
  { get label() { return uiText("Dashboard"); }, tab: 'dashboard', get group() { return uiText("Analytics"); }, adminOnly: true },
  { get label() { return uiText("Token usage"); }, tab: 'token', get group() { return uiText("Analytics"); }, adminOnly: true },
  // AI チャット
  { get label() { return uiText("AI Chat (internal RAG)"); }, tab: 'rag', get group() { return uiText("AI Chat"); } },
];

const ManagementPanel: React.FC<ManagementPanelProps> = ({
  isOpen,
  onClose,
  onNavigateTo,
  isAdmin,
  isPublishEnabled,
}) => {
  if (!isOpen) return null;

  const visibleItems = PANEL_ITEMS.filter((item) => {
    if (item.adminOnly && !isAdmin) return false;
    if (item.publishOnly && !isPublishEnabled) return false;
    return true;
  });

  const groups = [...new Set(visibleItems.map((i) => i.group))];

  const handleItemClick = (tab: HomeTabKey) => {
    onNavigateTo(tab);
    onClose();
  };

  return (
    <>
      {/* オーバーレイ */}
      <div className="mgmt-panel__overlay" onClick={onClose} />
      {/* パネル本体 */}
      <div className="mgmt-panel">
        <div className="mgmt-panel__header">
          <span className="mgmt-panel__title">{uiText("Manage")}</span>
          <button className="mgmt-panel__close" onClick={onClose} aria-label={uiText("Close")}>
            ✕
          </button>
        </div>
        <div className="mgmt-panel__body">
          {groups.map((group) => (
            <div key={group} className="mgmt-panel__group">
              <p className="mgmt-panel__group-label">{group}</p>
              <div className="mgmt-panel__items">
                {visibleItems
                  .filter((i) => i.group === group)
                  .map((item) => (
                    <button
                      key={item.tab}
                      className="mgmt-panel__item"
                      onClick={() => handleItemClick(item.tab)}
                    >
                      {item.label}
                    </button>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ManagementPanel;
